import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import { RescheduleIcon } from '~/modules/common/components/Icons';

const useStyles = makeStyles(theme => ({
  rescheduleButton: {
    ...theme.typography.caption,
    textTransform: 'none',
    padding: theme.spacing(0)
  }
}));

const rescheduleIcon = <RescheduleIcon />;

const RescheduleButton = ({
  onClick,
  isDisabled,
  isRolledUpTaskEstimateCalculationMethodEnabled,
  showIcon = true
}) => {
  const classes = useStyles();
  const buttonClasses = classNames(classes.rescheduleButton);

  return (
    <Button
      color="primary"
      variant="text"
      onClick={onClick}
      disabled={isDisabled}
      className={buttonClasses}
      startIcon={showIcon && rescheduleIcon}
      data-qe-id="TaskDrawer_Reschedule_Button"
    >
      <FormattedMessage id="taskDrawer.rescheduleButton" />
    </Button>
  );
};

RescheduleButton.propTypes = {
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  isRolledUpTaskEstimateCalculationMethodEnabled: PropTypes.bool,
  showIcon: PropTypes.bool
};

export default RescheduleButton;
